module.exports = __webpack_public_path__ + "img/delete_people.106da3c2.png";